import {css, StyleSheet} from 'aphrodite';
import * as React from 'react';
import _ from 'underscore';

import {InventoryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import isBatchesEnabled from 'registry/IsBatchesEnabled';
import {FONT_FAMILY_PROXIMA} from 'styles/FontConstants';
import * as Colors from 'ui-library/Colors';
import Option from 'ui-library/menus/Option';
import {WORKLIST_TYPE_TO_ICON, WorklistType} from 'worklists/WorklistConstants';

export interface WorklistTypesMenuProps {
  onSelectWorklistType: (worklistType: WorklistType) => void;
  getOptionText: (worklistType: WorklistType) => string;
  // Optionally specify a reduced set of worklist types to include in the displayed options
  availableWorklistTypes?: Array<WorklistType>;
}

export function renderWorklistTypeOptions(props: WorklistTypesMenuProps): Array<JSX.Element> {
  let worklistTypes = props.availableWorklistTypes || Object.values(WorklistType);
  if (!isBatchesEnabled()) {
    worklistTypes = worklistTypes.filter((worklistType) => worklistType !== WorklistType.BATCH);
  }
  if (!isFeatureEnabled({feature: InventoryFeature.INVENTORY_DISCOVER})) {
    worklistTypes = worklistTypes.filter(
      (worklistType) => ![WorklistType.CONTAINER, WorklistType.PLATE].includes(worklistType)
    );
  }
  return _.sortBy(worklistTypes, (type) => type).map((worklistType: WorklistType) => (
    <Option
      key={worklistType}
      value={worklistType}
      icon={WORKLIST_TYPE_TO_ICON[worklistType]}
      iconClassName={css(styles.icon)}
      contentClassName={css(styles.worklistTypeText)}
      onSelect={props.onSelectWorklistType}
      dataTestAttrs={{component: 'WorklistTypeOption', element: 'root', key: worklistType}}
    >
      {props.getOptionText(worklistType)}
    </Option>
  ));
}

const styles = StyleSheet.create({
  icon: {
    color: Colors.GRAY,
    margin: 8,
    marginRight: 14,
  },
  worklistTypeText: {
    fontSize: 13,
    fontFamily: FONT_FAMILY_PROXIMA,
    marginLeft: 8,
    marginRight: 8,
  },
});
